<template>
  <v-container>
    <v-toolbar>
          <v-toolbar-title>Username & Password</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn text v-on:click="gotoNext()">
            Next
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </v-toolbar>
        <br>
    <v-card>
      <v-card-text>
        <v-text-field
              v-model="signupEmail"
              label="Email"
              v-on:change="checkEmail"
              v-bind:error="emailError"
              v-bind:hint="emailHint"
        ></v-text-field>
        <v-text-field
              v-model="signupPassword"
              label="Password"
              type="password"
              hint="At least 8 characters"
              v-bind:error="passwordError"
        ></v-text-field>
        <v-text-field
              v-model="passwordConfirmed"
              label="Confirm your password"
              type="password"

        ></v-text-field>
        <v-btn v-if="!emailError && !passwordError" color="success" v-on:click="gotoNext">Next</v-btn>
      </v-card-text>
    </v-card>
    <v-dialog v-model="emailError" persistent max-width="350">
            <v-card>
              <v-card-title class="headline">Email is already in use.</v-card-title>
              <v-card-text>An account is already using that email. Please use another email address.</v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="warning" text v-on:click="emailError = false; signupEmail='';">OK</v-btn>
              </v-card-actions>
            </v-card>
    </v-dialog>
    
  </v-container>

  
</template>

<script>

  import {mask} from 'vue-the-mask';

  import gql from 'graphql-tag'; 
  
  const checkEmailQry = gql`
    query checkEmail($email: String) {
      checkEmail(email: $email) {
        user_id
        email
      }
    }
  `;

  import SignupMixin from '../mixins/SignupMixin';

  export default {
    name: 'SignupEmailAndPassword',
    directives: {
      mask
    },
    mixins: [SignupMixin],
    computed: {
      
    },
    data: () => ({
      availableNumbers: [],
      passwordConfirmed: null,
      passwordError: false,
      emailError: false,
      emailHint: '',
    }),
    methods: {
      checkEmail: function() {
        let self = this;
        return new Promise(function(resolve,reject) {  
            let variables = {
              email:  self.signupEmail,
            };
            self.$global.apolloClient.query({query: checkEmailQry, variables, fetchPolicy: 'network-only'})
            .then( function(result) {
              if (result.data.checkEmail.user_id == -1) {
                // user does not exist
              } else {
                // user exists already
                console.log('user exists already');
                self.emailError = true;
                self.emailHint = 'The user already exists.';
              }
              return resolve(true);
            });
        });     
      },
      checkPasswords: function() {
        console.log(this.passwordConfirmed + ' v ' + this.signupPassword)
        if (this.passwordConfirmed != this.signupPassword) {
          this.passwordError = true;
        } else {
          this.passwordError = false;
        }
      },
      chooseNumber(inventory) {
        this.selectedNumber = inventory.serialno;
      },
      gotoNext() {
        this.$emit('gotoNext');
      },
    },
    beforeMount() {
    },
    watch: {
      signupPassword: function() {
        this.checkPasswords();
      },
      passwordConfirmed: function() {
        this.checkPasswords();
      }
    },
    filters: {

    },
  }
</script>
